<script lang="ts">
	import { bannersHeight } from '@app/stores/banners';
	import { headerHeight } from '@app/stores/header';
	import { viewport } from '$lib/stores';

	let asideHeight: number;
	let windowInnerHeight: number;
</script>

<svelte:window bind:innerHeight={windowInnerHeight} />

<div class="relative grid grid-cols-1 lg:grid-cols-3 gap-x-7 lg:gap-x-5 2xl:gap-x-7">
	<div class="lg:col-span-2">
		<slot name="left-col" />
	</div>
	<aside
		bind:clientHeight={asideHeight}
		class="mt-4 lg:mt-0 lg:self-start"
		style={`top:${asideHeight < windowInnerHeight ? $bannersHeight + ($viewport.isDesktop ? $headerHeight : 0) : 0}px; position:${asideHeight < windowInnerHeight ? 'sticky' : 'relative'}`}
	>
		<div class="space-y-4">
			<slot name="right-col" />
		</div>
	</aside>
</div>
